import * as React from 'react';
import Typography from '@material-ui/core/Typography';

import { withIntl, IntlProps } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';

import FilterNumberInput from './FilterNumberInput';

interface Props {
  rooms: SearchFilters.RoomsFilterValue;
  className?: string;
  onChange: (type: string, value: number) => void;
  isDisabled: boolean;
}

export const RoomsFilter: React.SFC<Props & IntlProps> = ({
  rooms,
  onChange,
  intl: { T },
  isDisabled,
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Rooms')}</Typography>

    <FilterNumberInput
      value={rooms.bedroomCount}
      onChange={(value: number) => onChange('bedroomCount', value)}
      isDisabled={isDisabled}
    >
      {T('Number of bedrooms')}
    </FilterNumberInput>
  </React.Fragment>
);

export default withIntl(RoomsFilter);
